/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import CustomAddActionCard from '../../../../common/components/CustomAddActionCard/CustomAddActionCard';
import { Box, Grid, Typography } from '@mui/material';
import ApplyLoanModalController from '../../../../common/Modals/Loans/ApplyLoan/ApplyLoanModalController';
import _ from 'lodash';
import emptyIcon from '../../../../assets/images/empty_icon.svg';
import ActiveLoansTile from '../../../../common/components/ActiveLoansTile/ActiveLoansTile';
import { fonts, themes } from '../../../../common/themes/themes';
import ApplyLoanViewModalController from '../../../../common/Modals/Loans/ApplyLoanViewModal/ApplyLoanViewModalController';
import CustomAddButton from '../../../../common/components/CustomAddButton/CustomAddButton';
import {
  check_user_permission,
  getAmount,
} from '../../../../common/configs/utils';
import Loader from '../../../../common/Lottifiers/Loader/Loader';
import { useAppSelector } from '../../../../infra/hooks';

interface propsType {
  loansData: any;
  currency: any;
  isLoading?: boolean;
  pendingLoans?: any;
  trans?: any;
}

const ActiveLoansPresenter: React.FC<propsType> = ({
  loansData,
  currency,
  isLoading,
  trans,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [openViewModal, setOpenViewModal] = useState(false);
  const [loanViewModalData, setLoanViewModalData] = useState({});
  const auth_permissions = useAppSelector(
    (state: any) => state.authPermissionSlice?.authPermission,
  );

  const handleOpenAddModal = () => {
    setOpenModal(true);
  };
  return (
    <>
      <CustomAddActionCard
        card_title={trans('Active Recurring Payments')}
        card_height="330px"
        onClick={() => handleOpenAddModal()}
        card_subtitle={`${trans('Total')}: ${loansData?.length}`}
      >
        {isLoading ? (
          <Loader height={100} width={200} />
        ) : (
          <div>
            {loansData?.length > 0 ? (
              _.map(loansData, (loan: any, i) => {
                return (
                  <div key={i}>
                    <Box style={{ marginBottom: '24px' }} />
                    <ActiveLoansTile
                      loanName={loan?.type?.name}
                      duration={loan?.duration}
                      submitted={loan?.created_at}
                      amount={
                        loan?.amount
                          ? currency + ' ' + getAmount(loan?.amount)
                          : '--'
                      }
                      status={loan?.status}
                      isFinished={false}
                      onClickView={() => {
                        setLoanViewModalData(loan);
                        setOpenViewModal(true);
                      }}
                    />
                  </div>
                );
              })
            ) : (
              <Grid container>
                <Grid
                  item
                  xs={12}
                  style={{
                    textAlign: 'center',
                  }}
                >
                  <img src={emptyIcon} />
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    textAlign: 'center',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: fonts.fontFamily,
                      fontSize: fonts.title,
                      color: themes.blackDefault,
                      fontWeight: 'bold',
                    }}
                  >
                    {trans('Not Applied')}
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    textAlign: 'center',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: fonts.fontFamily,
                      fontSize: fonts.subtitle,
                      color: themes.defaultIcon,
                    }}
                  >
                    {trans('Currently you haven’t any loan Applications')}
                  </Typography>
                </Grid>
                {check_user_permission(auth_permissions, true, 'add') ? (
                  <Grid
                    item
                    xs={12}
                    style={{
                      textAlign: 'center',
                      marginTop: '1em',
                    }}
                  >
                    <CustomAddButton
                      btnLabel={trans('Apply Recurring Payment')}
                      onClick={() => setOpenModal(true)}
                    />
                  </Grid>
                ) : (
                  <></>
                )}
              </Grid>
            )}
          </div>
        )}
      </CustomAddActionCard>

      {/* Apply Loan Modal */}

      {openModal && (
        <ApplyLoanModalController
          isModalOpen={openModal}
          closeModal={() => setOpenModal(false)}
          trans={trans}
        />
      )}

      {/*View the loan detail Modal */}

      {openViewModal && (
        <ApplyLoanViewModalController
          isModalOpen={openViewModal}
          closeModal={() => setOpenViewModal(false)}
          loanViewModalData={loanViewModalData}
          trans={trans}
        />
      )}
    </>
  );
};

export default ActiveLoansPresenter;
